module.exports = __webpack_public_path__ + "img/PatentedNationwideSearchLogo.17936bfa.png";